import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text-underline",
  "use": "icon-text-underline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-text-underline\"><defs><style>#icon-text-underline .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M960,3143H938a1,1,0,0,0,0,2h22a1,1,0,0,0,0-2Z\" transform=\"translate(-937 -3121)\" /><path class=\"a\" d=\"M938.5,3123h2v9.5a8.5,8.5,0,0,0,17,0V3123h2a1,1,0,0,0,0-2h-6a1,1,0,0,0,0,2h2v9.5a6.5,6.5,0,0,1-13,0V3123h2a1,1,0,0,0,0-2h-6a1,1,0,0,0,0,2Z\" transform=\"translate(-937 -3121)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol